<div class="row">

	<!-- Top Panel -->
	<div class="col-sm-12">
	
		<!-- Keywords -->
		<div class="dropdown col-sm-6">
			<button class="btn btn-ef btn-sm dropdown-toggle" type="button" data-toggle="dropdown" style="margin-bottom: 10px">
				<i class="fa fa-info-circle" aria-hidden="true"></i>
				KEYWORDS
				<span class="caret"></span>
			</button>
			<ul class="dropdown-menu">
				<li *ngFor="let keyword of mAvailableKeywords" onmousedown="return false;" (click)="addKeyword(keyword)">
					<a style="cursor: pointer;">
						<i [ngClass]="keyword.classes" aria-hidden="true"></i>
						{{keyword.name}}
					</a>
				</li>
			</ul>
		</div>
		
		<!-- Recipients Label -->
		<div class="col-sm-6" style="color: #f57300">
			RECIPIENTS
		</div>
		
	</div>
	
	<!-- Message -->
	<div class="col-sm-6">
		<div class="panel panel-drk-ornge" style="border-color: #f57300">
			<div class="panel-body">
				<div 
					id="smsMessage_{{mUniqueIndex}}"
					contenteditable="true"
					[(appContentEditable)]="mMessageData.value"
					[keywords]="mAvailableKeywords"
					(modelChange)="updateMessage($event)"
					class="form-control eftextarea" 
					style="min-height: 163px; font-size: 18px; width: auto"
					>
				</div>
			</div>
		</div>
	</div>
	
	<!-- Recipients (Users, Numbers, Groups) -->
	<div class="col-sm-6">
	
		<!-- Add User Button -->
		<button type="button" class="btn btn-ef btn-sm" style="margin-right: 4px;" (click)="addDataForProperty(mProperty_ToUser)">
			+
			<span class="glyphicon glyphicon-user"></span>
			Add User
		</button>
		
		<!-- Add Group Button -->
		<button type="button" class="btn btn-ef btn-sm" style="margin-right: 4px;" (click)="addDataForProperty(mProperty_ToGroup)">
			+
			<span class="glyphicon glyphicon-option-vertical"></span>
			Add Group
		</button>
		
		<!-- Add Number Button -->
		<button type="button" class="btn btn-ef btn-sm" style="margin-right: 4px;" (click)="addDataForProperty(mProperty_ToNumber)">
			+
			<span class="glyphicon glyphicon-earphone"></span>
			Add Number
		</button>
		
		<br />
		<br />
		
		<!-- Added Recipients -->
		<div class="panel panel-drk-ornge" style="border-color: #f57300">
			<div class="panel-body">
				<ng-container *ngIf="mAction.data != null">
					<ng-container *ngFor="let data of mAction.data">
						<app-phone-number-editor *ngIf="data.property.property == mProperty_ToNumber"
							[mData]="data"
							(removeClicked)="removeData(data)"
							>
						</app-phone-number-editor>
						<app-user-selector *ngIf="data.property.property == mProperty_ToUser"
							[mData]="data"
							(removeClicked)="removeData(data)"
							>
						</app-user-selector>
						<app-user-group-selector *ngIf="data.property.property == mProperty_ToGroup"
							[mData]="data"
							(removeClicked)="removeData(data)"
							>
						</app-user-group-selector>
					</ng-container>
				</ng-container>
			</div>
		</div>
	</div>
	
</div>